import React, { useCallback, useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';
import { QuickDrawer } from 'shared/components';
import { TextField } from '@mui/material';
import { Button } from '../styles';

const InKindHelpDrawer = ({ open, onClose, onComplete }) => {
  const [values, setValue] = useState({
    volU: null,
    volH: null,
    volT: null,
    proU: null,
    proH: null,
    proT: null,
    donU: null,
    donH: null,
    donT: null,
    serU: null,
    serH: null,
    serT: null,
    totT: null,
  });

  const onChangeVal = (value, key) => {
    const newValues = cloneDeep(values);
    newValues[key] = value;
    console.log(newValues);
    setValue(newValues);
  };

  useEffect(() => {
    const newValues = cloneDeep(values);
    newValues.volT = (values.volU || 0) * (values.volH || 0);
    setValue(newValues);
  }, [values.volU, values.volH]);

  useEffect(() => {
    const newValues = cloneDeep(values);
    newValues.proT = (values.proU || 0) * (values.proH || 0);
    setValue(newValues);
  }, [values.proU, values.proH]);

  useEffect(() => {
    const newValues = cloneDeep(values);
    newValues.donT = (values.donU || 0) * (values.donH || 0);
    setValue(newValues);
  }, [values.donU, values.donH]);

  useEffect(() => {
    const newValues = cloneDeep(values);
    newValues.serT = (values.serU || 0) * (values.serH || 0);
    setValue(newValues);
  }, [values.serU, values.serH]);

  useEffect(() => {
    const newValues = cloneDeep(values);
    newValues.totT =
      parseFloat(values.volT || 0) +
      parseFloat(values.proT || 0) +
      parseFloat(values.donT || 0) +
      parseFloat(values.serT || 0);
    setValue(newValues);
  }, [values.volT, values.proT, values.donT, values.serT]);

  return (
    <QuickDrawer
      width="750px"
      title="Calculate the expected value of in-kind donations to Careers for All."
      open={open}
      onClose={onClose}
    >
      <DrawerContainer>
        <span>
          Enter projected values here to determine the total expected value.
        </span>
        <div class="t">
          <div class="r title">
            <div class="c">Donations</div>
            <div class="c">Hours or Units</div>
            <div class="c">Value per Hour/Unit</div>
            <div class="c">Total Value</div>
          </div>
          <div class="r">
            <div class="c">Volunteerism</div>
            <div class="c">
              <NumberField
                value={values.volU}
                onChange={(e) => onChangeVal(e.target.value, 'volU')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.volH}
                onChange={(e) => onChangeVal(e.target.value, 'volH')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.volT}
                onChange={(e) => onChangeVal(e.target.value, 'volT')}
              />
            </div>
          </div>
          <div class="r">
            <div class="c">Pro bono</div>
            <div class="c">
              <NumberField
                value={values.proU}
                onChange={(e) => onChangeVal(e.target.value, 'proU')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.proH}
                onChange={(e) => onChangeVal(e.target.value, 'proH')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.proT}
                onChange={(e) => onChangeVal(e.target.value, 'proT')}
              />
            </div>
          </div>
          <div class="r">
            <div class="c">Donated goods</div>
            <div class="c">
              <NumberField
                value={values.donU}
                onChange={(e) => onChangeVal(e.target.value, 'donU')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.donH}
                onChange={(e) => onChangeVal(e.target.value, 'donH')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.donT}
                onChange={(e) => onChangeVal(e.target.value, 'donT')}
              />
            </div>
          </div>
          <div class="r">
            <div class="c">Donated services</div>
            <div class="c">
              <NumberField
                value={values.serU}
                onChange={(e) => onChangeVal(e.target.value, 'serU')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.serH}
                onChange={(e) => onChangeVal(e.target.value, 'serH')}
              />
            </div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.serT}
                onChange={(e) => onChangeVal(e.target.value, 'serT')}
              />
            </div>
          </div>
          <div class="r">
            <div class="c">Total value</div>
            <div class="c space"></div>
            <div class="c space"></div>
            <div class="c">
              <span>$ </span>
              <NumberField
                value={values.totT}
                onChange={(e) => onChangeVal(e.target.value, 'totT')}
              />
            </div>
          </div>
        </div>
        <div class="btn-container">
          <BtnOut onClick={onClose}>Back</BtnOut>
          <Btn disabled={!values.totT} onClick={() => onComplete(values.totT)}>
            Add Total to Report
          </Btn>
        </div>
      </DrawerContainer>
    </QuickDrawer>
  );
};

export default InKindHelpDrawer;

const DrawerContainer = styled.div`
  width: 100%;
  padding: 30px;
  background-color: #f9f9f9;
  height: 100%;
  .btn-container {
    display: flex;
    position: relative;
  }
  span {
    font-size: 17px;
    color: #505050;
  }
  .t {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    .r {
      flex: 1;
      display: flex;
      flex-direction: row;
      padding: 15px;
      .c {
        flex: 1;
        span {
          display: inline-block;
          margin-top: 9px;
          margin-right: 4px;
        }
      }
    }
    .r.title {
      .c {
        font-weight: 700;
      }
    }
  }
`;
const Btn = styled(Button)`
  width: 40%;
  span {
    color: #ffffff;
  }
`;
const BtnOut = styled(Button).attrs({
  variant: 'outlined',
})`
  width: 40%;
  span {
    color: #0073a3;
  }
`;
const NumberField = styled(TextField).attrs({
  type: 'number',
  min: 1,
  step: '.01',
})`
  max-width: 85px;
  margin-top: 0px !important;
  background-color: #ffffff !important;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input {
    -moz-appearance: textfield;
  }
`;
